module.exports = __webpack_public_path__ + "static/media/home-presentation-image-01.ee554567.jpg";